import React from "react";
import OtpInput from 'react-otp-input';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { CandidateAlreadyRegitered, InvalidOtp, SomethingWrong } from "../../Helper/ErrorMessages";

const LoginOtp = (props) => {



  // const [UserData, setUserData] = useState('');
  // const [Otp, setOtp] = useState(null);
  // const [OtpEntered, setOtpEntered] = useState('');
  // const navigate=useHistory()

  // useEffect(() => {
  //   // Notiflix.Loading.init({ svgColor: "#c16d18" });

  //   const Data = JSON.parse(localStorage.getItem('loginOtp'));
  //   // const Data1 = JSON.parse(localStorage.getItem('LoginDetailsJobOtp'));

  //   if (Data != null) {
  //     setUserData(Data);
  //     setOtp(Data?.otp);
  //   } else {
  //     // window.location.href = '/login';
  //   }
  // }, []);

  const onChangeHandler = (e) => {

    props.onChange(e)
 

  };

  return (
    <div className="App">
      <ToastContainer />
      {/* <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-header">
                <h3>Login</h3>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <section id="content" className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-6 col-xs-12">
              <div className="page-login-form box">
                <h3>
                  OTP
                  <p
                    style={{
                      fontSize: '14px',
                      fontWeight: 'normal',
                      textTransform: 'initial'
                    }}
                  >OTP has been sent to you <br /> Kindly enter OTP to login.</p>
                </h3>
                <form className="login-form" onSubmit={(e) => { e.preventDefault(); }}>
                  <div className="form-group otp-login">
                    <OtpInput
                      value={props.value}
                      onChange={(e) => onChangeHandler(e)}
                      numInputs={6}
                      separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                    />
                  </div>

                  <button className="btn btn-common log-btn mt-3" onClick={props.verifyHandler}>
                    Login
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginOtp;
